import {
  ErrorMessage,
  Field,
  type FormikErrors,
  type FormikTouched,
  type FormikValues,
} from 'formik';
import * as React from 'react';
import { undoCamelCase } from '../../helpers/undoCamelCase';

interface SignupFieldInterface {
  id: string;
  errors: FormikErrors<FormikValues>;
  touched: FormikTouched<FormikValues>;
  placeholder: string;
  type: string;
  disabled: string;
}

/**
 * SignupField component renders an input field for signup form
 * @param {Object} props - The props object containing the properties for SignupField component
 * @param {string} props.id - The unique identifier for the input field
 * @param {Object} props.errors - The validation errors object
 * @param {Object} props.touched - The touched fields object
 * @param {string} props.placeholder - The placeholder text for the input field
 * @param {string} props.type - The type of the input field
 * @returns {ReactElement} - The rendered SignupField component
 */
export const SignupField = (
  props: SignupFieldInterface,
): React.ReactElement => {
  const { id, errors, touched, type, disabled } = props;
  const hasError = touched[id] && errors[id];
  return (
    <div className="Signup__UserInput">
      <Field
        className={`Signup__FormInput form-control ${
          hasError ? 'is-invalid' : null
        }`}
        disabled={disabled}
        id={id as string}
        name={id as string}
        pattern={undefined}
        placeholder={undoCamelCase(id)}
        type={id === 'phoneNumber' ? 'tel' : type}
      />
      <ErrorMessage
        className="custom-invalid-feedback"
        component="p"
        name={id as string}
      />
    </div>
  );
};
